// extracted by mini-css-extract-plugin
export default {"container":"_2qytJm","tablist":"_3jrEST","tab":"_3l__tJ","selected":"_9-821R","tabpannel":"_3vdsmd","selectedTabPanel":"_271m_Q"};